const handleGooglePlayLink = (userId: string | null, locale: string = 'en') => {
  window.open('https://play.google.com/store/apps/details?id=com.spiritory.market&pli=1', '_blank');
};
const handleAppleStoreLink = (userId: string | null, locale: string = 'en') => {
  window.open('https://apps.apple.com/de/app/spiritory-whisky-wein-app/id6469595208', '_blank');
};

export { handleGooglePlayLink, handleAppleStoreLink };
